<div class="page">
  <app-page-header page-title="companies.add.pageTitle"></app-page-header>
  <div class="page-content">

    <!-- ANAGRAPHIC CARD -->
    <mat-card class="custom-card">
      <mat-card-title>{{ 'companies.add.addTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.addTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="detailCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="form-wrapper mt-3">
            <form [formGroup]="form" (ngSubmit)="onFormSubmit(1)">
              <formly-form [form]="form" [fields]="anagraphicFields" [model]="model" [options]="options"></formly-form>
              <mat-spinner-button role="submit" [options]="formBtnOptions" class="btn-elevate">
              </mat-spinner-button>
            </form>
          </div>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

    <!-- CONTRACT CARD -->
    <mat-card class="custom-card mt-4" *ngIf="model && model.types && model.types.includes('manager')">
      <!-- <mat-card class="d-none custom-card mt-4" [ngClass]="{ 'd-block': model && model.types && model.types.includes('manager')}"> -->
      <mat-card-title>{{ 'companies.fields.subscription.titleSection' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.editTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="contractCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="form-wrapper mt-3">
            <form [formGroup]="formSC" (ngSubmit)="onFormSubmit(2)">
              <formly-form [form]="formSC" [fields]="contractFields" [model]="modelSC" [options]="optionsSC"></formly-form>
              <mat-spinner-button role="submit" [options]="formBtnOptionsSC" class="btn-elevate">
              </mat-spinner-button>
            </form>
          </div>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->